import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import { APP_ENV } from './lib/constants.ts';

Sentry.init({
    dsn: 'https://3384e6aeae92e373d2e8835733016d4e@o4505652550893568.ingest.us.sentry.io/4506854571835392',
    environment: APP_ENV,

    // Sampled traces propagate to the server (parent-based sampling), so this
    // rate also drives server-side tracing for browser-initiated requests.
    tracesSampler: ({ name, parentSampled }) => {
        if (name.startsWith('/admin')) {
            return 0;
        }
        if (parentSampled !== undefined) {
            return parentSampled;
        }
        return APP_ENV === 'production' ? 0.1 : 0;
    },

    // Deep enough that tRPC query inputs attached to errors aren't truncated.
    normalizeDepth: 10,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    replaysOnErrorSampleRate: 0,

    enabled: process.env.NODE_ENV === 'production',

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0,
    integrations: [
        Sentry.browserTracingIntegration({
            ignoreResourceSpans: ['resource.script', 'resource.link', 'resource.img', 'resource.other'],
        }),
        Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true,
        }),
        Sentry.reactRouterV7BrowserTracingIntegration({
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
    ],
});
